import request from '@/services/interceptor.js'


//ritorna il valore limite del grafico calcolato in base al valore maggiore presente dei dati
export const get_chartMax = (par) => {
  return request({
    url: '/api/statistiche/grafico/max',
    method: 'post',
    data: par,
  })
}

export const get_statisticheSerie = (par) => {
  return request({
    url: '/api/statistiche/serie/' + par,
    method: 'get'
  })
};

export const get_tabella = (par, date) => {
  return request({
    url: '/api/statistiche/tabella' + par,
    method: 'post',
    data: date
  })
};

export const get_tabellaAgente = (par, date) => {
  return request({
    url: '/api/statistiche/agente/tabella' + par,
    method: 'post',
    data: date
  })
};

export const get_pdf = (par, date) => {
  return request({
    url: '/api/statistiche/pdf' + par,
    method: 'post',
    data: date,
    responseType: 'blob',
    loadingBar: false
  })
};

/* export const get_pdfStatistiche = (par, date) => {
  return request({
    url: "/api/statistiche/pdf/serie/" + par,
    method: 'post',
    data: date,
    responseType: 'blob',c
  })
} */

export const get_tendenze = (par) => {
  return request({
    url: '/api/statistiche/tendenze/' + par,
    method: 'get'
  })
};

export const get_tendenze_dett = (par, data) => {
  return request({
    url: '/api/statistiche/tendenze/' + par,
    method: 'post',
    data: data
  })
};


export const get_promozioni = (par, data) => {
  return request({
    url: '/api/statistiche/promozioni/dati' + par,
    method: 'post',
    data: data
  })
}

export const get_dettaglioExClienti = (par, data) => {
  return request({
    url: '/api/statistiche/tendenze/exclienti' + par,
    method: 'post',
    data: data
  })
}

export const get_pdfExClienti = (par, data) => {
  return request({
    url: '/api/statistiche/tendenze/exclienti/pdf' + par,
    method: 'post',
    data: data,
    responseType: 'blob',
    loadingBar: false
  })
}


export const get_trimestre = (par) => {
  return request({
    url: '/api/statistiche/trimestre' + par,
    method: 'get'
  })
};
